import { get, writable } from 'svelte/store';
export const router = writable({
    page: '/'
});
export const account = writable({
    isAuthorized: false,
    name: '',
    password: ''
});
function getSession() {
    let session;
    const rawSession = localStorage.getItem('session');
    if (rawSession)
        session = JSON.parse(rawSession);
    else
        session = {
            'router': {},
            'account': {}
        };
    return session;
}
export function saveAccount() {
    const session = getSession();
    const accountData = get(account);
    for (const [key, value] of Object.entries(accountData)) {
        session['account'][key] = value;
    }
    localStorage.setItem('session', JSON.stringify(session));
}
export function saveRouter() {
    const session = getSession();
    const routerData = get(router);
    for (const [key, value] of Object.entries(routerData)) {
        session['router'][key] = value;
    }
    localStorage.setItem('session', JSON.stringify(session));
}
export function load() {
    const session = getSession();
    if (session['router'])
        router.update(data => {
            for (const [key, value] of Object.entries(session['router']))
                data[key] = value;
            return data;
        });
    if (session['account'])
        account.update(data => {
            for (const [key, value] of Object.entries(session['account']))
                data[key] = value;
            return data;
        });
}
